
export class SubscribeModel {
    constructor() { }
    public SubscribeId: number;
    public SubscribeEmail: string;
  }
